<template>
  <div v-if="open" class="mobile-menu" :class="{'mobile-menu--closing': closing}">
    <padding v-for="name in routes" :key="name" direction="vertical" class="flex--middle flex--justify-middle">
      <router-link :to="routePaths[name]" class="header-link flex--middle flex--justify-middle">
        <Button colour="grey" type="text" :icon="routeIcons[name]" class="button--header" @click="closeMobileMenu">
          {{ routeLabels[name] }}
        </Button>
      </router-link>
    </padding>

    <padding direction="vertical" class="flex--middle flex--justify-middle">
      <div class="mobile-menu__divider"></div>
    </padding>

    <padding direction="vertical" class="flex--middle flex--justify-middle">
      <router-link to="/account" class="header-link flex--middle flex--justify-middle">
        <Button colour="grey" type="text" icon="user" class="button--header" @click="closeMobileMenu">
          Account
        </Button>
      </router-link>
    </padding>
    <padding direction="vertical" class="flex--middle flex--justify-middle">
      <Button colour="grey" type="text" icon="sign-out" class="button--header" @click="logout">
        Sign Out
      </Button>
    </padding>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { path } from 'ramda'
import Padding from '../Utils/Padding'
import navMenuMixin from '../../mixins/navMenuMixin'
import Button from '../Buttons/Button'

export default {
  name: 'MobileMenu',
  components: { Button, Padding },
  mixins: [navMenuMixin],
  data() {
    return {
      closing: false,
      open: false,
    }
  },
  computed: {
    ...mapState(
      {
        mobileMenuOpen: path(['mobileMenuOpen']),
      },
    ),
  },
  watch: {
    mobileMenuOpen() {
      if (this.mobileMenuOpen) {
        this.open = true
      } else {
        this.closing = true
        setTimeout(() => {
          this.open = false
          this.closing = false
        }, 300)
      }
    },
  },
  methods: {
    ...mapActions(
      {
        closeMobileMenu: 'closeMobileMenu',
      },
    ),
  },
}
</script>
